import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PSPImage from "../../assets/img/3 month Pinterest success plan.webp";

//MUI stuff
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import { TextField, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { validateEmail } from "../../utils/utilityFunctions";
import axios from "axios";

const useStyles = makeStyles()((theme) => ({
  dialogContent: {
    padding: 0,
    paddingTop: 0,
    "&:first-of-type": {
      paddingTop: 0,
    },
  },
  dialogActions: {
    paddingRight: 30,
    paddingBottom: 20,
  },
  parentDiv: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    overflowY: "hidden",
    overflowX: "hidden",
  },

  imageDiv: {
    display: "flex",
  },
  popUpImage: {
    width: "100%",
  },
  textField: {
    width: "90%",
    margin: "10px 20px 10px 20px",
  },
  successMessage: {
    margin: 30,
  },
}));

export const PopUpDialog = (props) => {
  const { classes } = useStyles();

  const [isOpen, setIsOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [isError, setIsError] = useState(false);
  const [isSignupSuccess, setIsSignupSuccess] = useState(false);

  useEffect(() => {
    // open the dialog after 45 seconds
    let popUpTimer = setTimeout(
      (isUserAuthenticated, isNewsletterSubscriber) => {
        if (!isUserAuthenticated && !isNewsletterSubscriber) {
          setIsOpen(true);
        }
      },
      60000,
      props.user.authenticated,
      JSON.parse(localStorage.getItem("isNewletterSubscriber"))
    );
    return () => {
      clearTimeout(popUpTimer);
    };
  }, [props.user.authenticated]);

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleGetSuccessPlan = () => {
    setIsError(false);

    if (validateEmail(email)) {
      axios
        .post("/api/user/newsletterSignup", { email: email })
        .then(() => {
          setIsSignupSuccess(true);
        })
        .catch((err) => {
          console.error("Failed to record email signup");
          console.log(err);
        });

      localStorage.setItem("isNewletterSubscriber", true);
    } else {
      setIsError(true);
    }
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogContent classes={{ root: classes.dialogContent }}>
        {isSignupSuccess ? (
          <div>
            <Typography className={classes.successMessage}>
              Please check your email for the download link
            </Typography>
          </div>
        ) : (
          <div className={classes.parentDiv}>
            <div className={classes.imageDiv}>
              <img src={PSPImage} className={classes.popUpImage} />
            </div>
            <TextField
              value={email}
              variant="outlined"
              autoFocus
              margin="dense"
              id="emailAddress"
              label="Type your email address here"
              type="email"
              required
              className={classes.textField}
              onChange={(e) => setEmail(e.target.value)}
              error={
                isError || (email.length > 0 && !validateEmail(email))
                  ? true
                  : false
              }
              helperText={
                isError || (email.length > 0 && !validateEmail(email))
                  ? "Please enter a valid email address"
                  : ""
              }
            />
          </div>
        )}
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button onClick={handleClose} color="primary">
          Close
        </Button>
        {!isSignupSuccess ? (
          <Button
            onClick={handleGetSuccessPlan}
            color="primary"
            variant="contained"
          >
            Download Success plan
          </Button>
        ) : null}
      </DialogActions>
    </Dialog>
  );
};

PopUpDialog.propTypes = {
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PopUpDialog);
